export const SNAPSHOT_PERMISSIONS = {
  VIEW: 'snapshots.view_snapshot',
  ADD: 'snapshots.add_snapshot',
  CHANGE: 'snapshots.change_snapshot',
  DELETE: 'snapshots.delete_snapshot',
};

export const SNAPSHOT_EDIT_PERMISSIONS = [SNAPSHOT_PERMISSIONS.ADD, SNAPSHOT_PERMISSIONS.CHANGE];
